import React from 'react';
import '../css/SmallCard.css';

export default class SmallCard extends React.Component {

	render(){
		return(
			<div className="cardmain" onClick={()=>this.props.setToken(this.props.piece)}>
				<div className="rarityrank kfont">#{this.props.piece.token}</div>
				<div><img className="smallcardimg" src={'/tokens/'+this.props.piece.token+'.jpg'} width="150" height="150" alt={"Token " + this.props.piece.token}  /></div>
				<div className="pieceid kfont">T.O.T.A #{this.props.piece.token}</div>
			</div>
		);
	}
}
